// @flow

import sortBy from 'lodash/sortBy';
import { Map } from 'immutable';
import React from 'react';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import ShowAt from 'react-aaui/lib/viewport/ShowAt';
import type { RouteStagePointWithResult } from 'type/type';

import NoRecord from 'components/NoRecord/NoRecord';
import ResultList from './ResultList/ResultList';
import { getSplitWithResults, isTriathlonResult, isLiveResult } from '../duck/selector';
import RouteChart from './RouteChart/RouteChart';
import './SplitResults.scss';

type Props = {
  results: RouteStagePointWithResult[],
  isLive: boolean,
  isTriathlon: boolean,
}

export const SplitResults = ({ results, isTriathlon, isLive }: Props) => {
  let sortedResults = sortBy(results, [ 'stageSequence', 'sequence' ]);
  if (isLive) {
    sortedResults = sortedResults.reverse().filter(r => !!r.result && (r.result.missing || r.result.result !== null));
  }
  const hasResult = sortedResults
    && sortedResults.filter(r => !!r.result && (r.result.missing || r.result.result !== null)).length > 0;

  return hasResult ? (
    <div className="participant-split-results">
      <ShowAt smAndAbove>
        <div className="participant-split-results__chart">
          <RouteChart splitPoints={sortedResults} isLive={isLive} />
        </div>
      </ShowAt>
      <div className="participant-split-results__list">
        <ResultList
          results={sortedResults}
          isTriathlon={isTriathlon}
          isLive={isLive} />
      </div>
    </div>
  ) : (
    <NoRecord />
  );
};

const mapState = (state: Map<*, *>) => ({
  results: getSplitWithResults(state),
  isTriathlon: isTriathlonResult(state),
  isLive: isLiveResult(state),
});

export default connect(mapState)(SplitResults);
